module.exports = "/_next/static/files/8392219bb3cf624822b91e4ad0ed87ce.jpg";